export const BAR_HEIGHT = 35;
export const MARGIN_LEFT = 15;
export const TARGET_PERCENTAGE = 0.95;
export const DATE_FORMAT = 'EEE dd MMM HH:mm';
